export const socialsData = {
    github: 'https://github.com/MohammadMahbub',
    facebook: 'https://www.facebook.com/ahmed.mahbub1996/',
    linkedIn: 'https://www.linkedin.com/in/mohammad-mahbub-8828721b7/',
    instagram: 'https://www.instagram.com/mohammad_mahbub1/',
    twitter: 'https://twitter.com/Mahbub1Mohammad',

}